import { getEntityList } from '../../api/GetEntityMasterApi.js'
import { getTANBYEntityUUID } from '../../api/adminTAN.js'
import { getAllocationStatus } from '../../api/allcoation.js'
import { getQuartersTypes, getReturnsTypes } from '../../api/returnsStep.js'
import {
  fetchEntityStart,
  fetchEntitySuccess,
  fetchEntityFailure,
  fetchTanStart,
  fetchTanSuccess,
  fetchTanFailure,
  fetchAllocationStatusStart,
  fetchAllocationStatusSuccess,
  fetchAllocationStatusFailure,
  fetchQuarterStatusStart,
  fetchQuarterStatusSuccess,
  fetchQuarterStatusFailure,
  fetchReturnStatusStart,
  fetchReturnStatusSuccess,
  fetchReturnStatusFailure,
} from '../slice/entityTanSlice.js'

// ✅ Fetch Entity List only if not cached
export const fetchEntityListIfNeeded =
  payload => async (dispatch, getState) => {
    const { entityList } = getState().entityTan
    if (entityList) return

    try {
      dispatch(fetchEntityStart())
      const response = await getEntityList(payload)
      dispatch(fetchEntitySuccess(response.data.data))
    } catch (error) {
      dispatch(fetchEntityFailure(error.message))
    }
  }

// ✅ Fetch TAN by Entity UUID only if not cached
export const fetchTANByEntityIfNeeded =
  entityUuid => async (dispatch, getState) => {
    const { tanListByEntity } = getState().entityTan
    if (tanListByEntity[entityUuid]) return // Already cached

    try {
      dispatch(fetchTanStart())
      const response = await getTANBYEntityUUID(entityUuid)
      dispatch(
        fetchTanSuccess({
          entityUuid,
          tanList: response || [],
        })
      )
    } catch (error) {
      dispatch(fetchTanFailure(error.message))
    }
  }

export const fetchAllocationStatusIfNeeded = () => async dispatch => {
  try {
    dispatch(fetchAllocationStatusStart())
    const response = await getAllocationStatus()

    dispatch(fetchAllocationStatusSuccess(response.data || []))
  } catch (error) {
    dispatch(
      fetchAllocationStatusFailure(
        error.message || 'Failed to fetch allocation status'
      )
    )
  }
}

export const fetchQuarterType = () => async dispatch => {
  try {
    dispatch(fetchQuarterStatusStart())
    const response = await getQuartersTypes()    
    dispatch(fetchQuarterStatusSuccess(response.data.data || []))
  } catch (error) {
    dispatch(
      fetchQuarterStatusFailure(
        error.message || 'Failed to fetch allocation status'
      )
    )
  }
}

export const fetchReturnType = () => async dispatch => {
  try {
    dispatch(fetchReturnStatusStart())
    const response = await getReturnsTypes()
    dispatch(fetchReturnStatusSuccess(response.data.data || []))
  } catch (error) {
    dispatch(
      fetchReturnStatusFailure(
        error.message || 'Failed to fetch allocation status'
      )
    )
  }
}
